import React from "react"
import { RouteComponentProps } from "@reach/router"
import { GlobalOverflowHidden } from "./styles/UnauthStyles"
import { IFrame } from "../integration/iframe"

export const CreateClaimSubmission: React.FC<RouteComponentProps> = ({ path = `` }) => (
  <>
    <GlobalOverflowHidden />
    <IFrame path={path} />
  </>
)
